<template>
    <div v-if="isShow" :style="domStyle" class="badgeStyle">
        <Badge :count="count" overflow-count="99" :offset="dot_offset" :style="badgeStyle">
            <img :src="picPath" :width="picWidth" :height="picHeight">
        </Badge>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        this.defaultTailoring = this.parentObject.defaultTailoring;
        this.windowSize = this.parentObject.windowSize;
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px",
            textAlign : 'center',
            lineHeight : this.height + "px"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
    },
    data(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            badgeStyle: {
                display:"flex",
                alignItems:"center",
                justifyContent:"center"
            },
            // 版本号
            version: "10.0.3.1"
        }
    },
    computed: {
        // 计算徽标所在距离容器顶部的距离
        dot_offset(){
            var top = parseInt(this.height / 1.6 - this.height/5);
            var right = parseInt(this.width /2 - this.height/3);
            return [top,right];
        },
        picWidth(){
            return this.domStyle.width;
        },
        picHeight(){
            return this.domStyle.height;
        }
    },
    methods : {
        /*
            参数：src 原json数据
            作用：混淆数据到当前对象
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
        },
        /*
            参数：无
            作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
        */
        onClose(){
            return new Promise((resolve)=>{
                resolve();
            })
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            this.domStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.domStyle.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height =  parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        /*
            参数：num 设置数值
            作用：徽标展示值变更
        */
        SetLogoShow(num){
            this.count = num;
            this.$forceUpdate();
        }
    }
}
</script>

<style>
    .badgeStyle .ivu-badge .ivu-badge-count{
        width: 25px;
        height: 15px;
        font-size: 12px;
        border-radius: 10px;
        line-height: 12px;
        padding:0;
        margin-top: 0px !important;
        margin-right: 0px !important;
        amimation:blink 2s linear infinite;
        -webkit-animation: blink 2s linear infinite;
        -moz-animation: blink 2s linear infinite;
        -ms-animation: blink 2s linear infinite;
        -o-animation: blink 2s linear infinite;
    }
    .badgeStyle .ivu-badge{
        height:100%;
    }

    @keyframes blink{
        0%{opacity:1;}
        25%{opacity:0.75;}
        50%{opacity:0.5;}
        74%{opacity:0.25;}
        100%{opacity:0;} 
    }

</style>


// WEBPACK FOOTER //
// src/components/primitives/fvBadge/fvBadge.vue